export default function NumberField({ label, value, onChange, step = 1 }: { label: string; value: number; onChange: (n: number) => void; step?: number }) {
    return (
      <label className="flex flex-col gap-1" style={{ display: 'flex' }}>
        <span className="text-gray-700">{label}</span>
        <input type="number" step={step} className="rounded-md border border-gray-300 px-3 py-2 w-full" value={value} onChange={(e) => {
          const raw = e.target.value;
          const normalized = raw && !raw.startsWith('0.') ? raw.replace(/^0+(?=\d)/, '') : raw;
          // Force the displayed value to the normalized string to remove leading zeros immediately
          e.currentTarget.value = normalized || '';
          onChange(parseFloat(normalized || '0'));
        }} />
      </label>
    );
}